import * as React from "react";
var EdModal = function (props) {
    var ref = React.useRef(null);
    React.useEffect(function () {
        var body = document.querySelector("body");
        body.style.overflow = props.show ? "hidden" : "auto";
        return function () {
            body.style.overflow = "auto";
        };
    }, [props.show]);
    React.useEffect(function () {
        if (!props.DisableOutsideClickClose) {
            var handleClickOutside_1 = function (event) {
                if (ref.current &&
                    !ref.current.contains(event.target) &&
                    event.view.innerWidth - 17 >= event.clientX) {
                    props.setShow(false);
                    (props === null || props === void 0 ? void 0 : props.onCloseGoBackFunction) && (props === null || props === void 0 ? void 0 : props.onCloseGoBackFunction());
                }
            };
            props.stopClossOnOutsideClick
                ? null
                : document.addEventListener("mousedown", handleClickOutside_1);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside_1);
            };
        }
    }, [ref]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "modal-backdrop ".concat(props.show ? "show" : "fade") }),
        React.createElement("div", { className: "modal ".concat(props.modalTitle, " ").concat(props.show ? "show" : "fade") },
            React.createElement("div", { className: "modal-dialog ".concat(props.size) },
                React.createElement("div", { className: "modal-content", ref: ref },
                    !props.hideHeader && (React.createElement("div", { className: "modal-header align-items-center justify-content-between" },
                        React.createElement("div", { className: "d-flex justify-conent-between align-items-center ".concat(props.iconClass && props.iconClass) },
                            props.icon && (React.createElement("i", { className: props.icon, onClick: function () { return props.iconOnClick(); } })),
                            props.title && (React.createElement("h5", { className: "modal-title" }, props.hasOwnProperty("title") ? props.title : ""))),
                        !props.hideCrossBtn && (React.createElement("button", { type: "button", className: props.ownCloseIcon
                                ? props.ownCloseIcon
                                : "edel-icon-bold-close", onClick: function () {
                                !props.onCloseGoBack && props.setShow(false);
                                setTimeout(function () {
                                    (props === null || props === void 0 ? void 0 : props.closeDropdown) && (props === null || props === void 0 ? void 0 : props.closeDropdown(false));
                                }, 0);
                                (props === null || props === void 0 ? void 0 : props.onCloseGoBack) && (props === null || props === void 0 ? void 0 : props.onCloseGoBackFunction());
                            } },
                            React.createElement("i", { className: "" }))))),
                    React.createElement("div", { className: "modal-body ".concat(props.modalbodyClass) }, props.children),
                    props.showFooter && (React.createElement("div", { className: "modal-footer" },
                        React.createElement("button", { type: "button", className: "btn btn-secondary", onClick: function () {
                                props.setShow(false);
                                setTimeout(function () {
                                    props.closeDropdown && props.closeDropdown(false);
                                }, 0);
                            } }, "Close"),
                        React.createElement("button", { type: "button", className: "btn btn-primary" }, "Save changes"))))))));
};
export default EdModal;
